
import { defineComponent, PropType } from 'vue'

import { WebhookEventDelivery } from '~/types/types'

/**
 * Component representing the webhook logs list
 */
export default defineComponent({
  name: 'WebhookLogList',
  props: {
    endpointDeliveries: {
      type: Array as PropType<Array<WebhookEventDelivery>>,
      required: true
    },
    endpointDeliveriesCount: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      currentPage: 1,
      limit: 8
    }
  },
  computed: {
    pageCount(): number {
      return Math.ceil(this.endpointDeliveriesCount / this.limit)
    }
  },
  methods: {
    /**
     * Method to update the current page number
     *
     * @param {number} pageNumber
     * @returns {void}
     */
    updateCurrentPage(pageNumber: number): void {
      this.currentPage = pageNumber

      // Emit an event supplying the page number
      this.$emit('update-page-number', pageNumber)
    }
  }
})
